<template>
    <div :class="'d-flex flex-column m-0 p-0 align-items-center bg-white px-2 py-2 w-100 ' + fh ">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name:"MainContainer",
    props: {
        onlyNav: {
            type: Boolean,
            default:false
        }
    },
    beforeMount() {              
        if (this.onlyNav) { this.fh = "fh-only-nav"; }
        else { this.fh = "fh"; }
    },   
    data() {
        return {
            fh:""
        }
    }
    
}
</script>

<style lang="css" scoped>
    .fh {
        height: calc(100vh - 104px);
        overflow-x: auto;
    }

    .fh-only-nav {
        height: calc(100vh - 54px);
        overflow-x: auto;
    }
</style>
